/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ooL7EhXDmFQWnW9sxtchhE
// Component: Cma6XahJmS

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  PlasmicLink as PlasmicLink__,
  renderPlasmicSlot,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_dashboard.css"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectcss
import sty from "./PlasmicNavWorkspaceButton.module.css"; // plasmic-import: Cma6XahJmS/css

import Icon19Icon from "./icons/PlasmicIcon__Icon19"; // plasmic-import: MHEeMLIhlB/icon

createPlasmicElementProxy;

export type PlasmicNavWorkspaceButton__VariantMembers = {
  selected: "selected";
  noIcon: "noIcon";
};
export type PlasmicNavWorkspaceButton__VariantsArgs = {
  selected?: SingleBooleanChoiceArg<"selected">;
  noIcon?: SingleBooleanChoiceArg<"noIcon">;
};
type VariantPropType = keyof PlasmicNavWorkspaceButton__VariantsArgs;
export const PlasmicNavWorkspaceButton__VariantProps =
  new Array<VariantPropType>("selected", "noIcon");

export type PlasmicNavWorkspaceButton__ArgsType = {
  name?: React.ReactNode;
  href?: string;
  icon?: React.ReactNode;
};
type ArgPropType = keyof PlasmicNavWorkspaceButton__ArgsType;
export const PlasmicNavWorkspaceButton__ArgProps = new Array<ArgPropType>(
  "name",
  "href",
  "icon"
);

export type PlasmicNavWorkspaceButton__OverridesType = {
  root?: Flex__<"a">;
  freeBox?: Flex__<"div">;
};

export interface DefaultNavWorkspaceButtonProps {
  name?: React.ReactNode;
  href?: string;
  icon?: React.ReactNode;
  selected?: SingleBooleanChoiceArg<"selected">;
  noIcon?: SingleBooleanChoiceArg<"noIcon">;
  className?: string;
}

const $$ = {};

function PlasmicNavWorkspaceButton__RenderFunc(props: {
  variants: PlasmicNavWorkspaceButton__VariantsArgs;
  args: PlasmicNavWorkspaceButton__ArgsType;
  overrides: PlasmicNavWorkspaceButton__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "selected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.selected,
      },
      {
        path: "noIcon",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.noIcon,
      },
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <PlasmicLink__
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "a",
        "a__ooL7E",
        "root_reset_ooL7EhXDmFQWnW9sxtchhE",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootnoIcon]: hasVariant($state, "noIcon", "noIcon"),
          [sty.rootselected]: hasVariant($state, "selected", "selected"),
        }
      )}
      href={args.href}
      platform={"react"}
    >
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames("all", sty.freeBox, {
          [sty.freeBoxnoIcon]: hasVariant($state, "noIcon", "noIcon"),
        })}
      >
        {(hasVariant($state, "noIcon", "noIcon") ? false : true)
          ? renderPlasmicSlot({
              defaultContents: (
                <Icon19Icon
                  className={classNames("all", sty.svg___9PPAp)}
                  role={"img"}
                />
              ),

              value: args.icon,
              className: classNames(sty.slotTargetIcon, {
                [sty.slotTargetIconnoIcon]: hasVariant(
                  $state,
                  "noIcon",
                  "noIcon"
                ),
              }),
            })
          : null}
      </div>
      {renderPlasmicSlot({
        defaultContents: "Workspace A",
        value: args.name,
        className: classNames(sty.slotTargetName, {
          [sty.slotTargetNamenoIcon]: hasVariant($state, "noIcon", "noIcon"),
          [sty.slotTargetNameselected]: hasVariant(
            $state,
            "selected",
            "selected"
          ),
        }),
      })}
    </PlasmicLink__>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox"],
  freeBox: ["freeBox"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "a";
  freeBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicNavWorkspaceButton__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicNavWorkspaceButton__VariantsArgs;
    args?: PlasmicNavWorkspaceButton__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicNavWorkspaceButton__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicNavWorkspaceButton__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNavWorkspaceButton__ArgProps,
          internalVariantPropNames: PlasmicNavWorkspaceButton__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicNavWorkspaceButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNavWorkspaceButton";
  } else {
    func.displayName = `PlasmicNavWorkspaceButton.${nodeName}`;
  }
  return func;
}

export const PlasmicNavWorkspaceButton = Object.assign(
  // Top-level PlasmicNavWorkspaceButton renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),

    // Metadata about props expected for PlasmicNavWorkspaceButton
    internalVariantProps: PlasmicNavWorkspaceButton__VariantProps,
    internalArgProps: PlasmicNavWorkspaceButton__ArgProps,
  }
);

export default PlasmicNavWorkspaceButton;
/* prettier-ignore-end */
